<template>
    <div class="contractPage" v-html="pageData"></div>
</template>

<script>
import api from '@/api'
export default {
    name: "Contract",
    data () {
        return {
            pageData: ""
        }
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '')
        this.initPage()
    },
    methods: {
        async initPage () {
            const { data } = await api.page.getContract()
            if (data && data.length > 0) {
                this.pageData = data
            }
        }
    }
}
</script>

<style lang="less">
.contractPage {
    background: white;
    padding: 0 0.75rem;
    padding-top: 10px;
    .f18 {
        font-size: .9rem;
    }
    .tc {
        text-align: center;
    }
}
</style>